import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useFavoriteCapabilityActive } from '~/context/vdp/NativeContext';
import { VdpDispatcherEvent } from '~/native/vdp/dispatchers/constants';
import {
  getIsFavoritesLoaded,
  getVehicleDetails,
  isCurrentVehicleFavorited
} from '~/selectors';
import useSelector from '~/store/useSelector';
import sendMessageToNative from './sendMessageToNative';

export default function useIsFavoriteDispatcher(): void {
  const isFavorite = useSelector(isCurrentVehicleFavorited);
  const isFavoriteCapabilityActive = useFavoriteCapabilityActive();
  const isFavoritesLoaded = useSelector(getIsFavoritesLoaded);
  const { stockNumber, vehicleId } = useSelector(getVehicleDetails);

  const shouldSendMessage = isFavorite && isFavoriteCapabilityActive;

  useEffectOnce(
    () => {
      if (!shouldSendMessage) return;

      sendMessageToNative(VdpDispatcherEvent.IsFavorite, {
        stockNumber,
        vehicleId
      });
    },
    [shouldSendMessage, stockNumber, vehicleId],
    isFavoritesLoaded
  );
}
